// extracted by mini-css-extract-plugin
export default {"header":"styles__header___A2a1K","headerInner":"styles__headerInner___Y9SqU","headerTitle":"styles__headerTitle___qdVoH fonts__whitney-semibold___M7vMo"};